import React from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { DAY_LABELS } from '../utils/constants';

// Recharts contentStyle is inline, so dark: classes don't apply. Resolve the
// theme from the root class at render time. (The previous var(--color-*) values
// were undefined, leaving the tooltip transparent/unreadable in dark mode.)
function tooltipStyle() {
  const dark = typeof document !== 'undefined'
    && document.documentElement.classList.contains('dark');
  return {
    backgroundColor: dark ? '#1f2937' : '#ffffff',
    border: `1px solid ${dark ? '#374151' : '#e5e7eb'}`,
    borderRadius: '8px',
    color: dark ? '#f3f4f6' : '#111827',
  };
}

export function CompletionRateChart({ weeklyRates, color }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-4">
      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
        Weekly Completion Rate
      </h3>
      <ResponsiveContainer width="100%" height={180}>
        <LineChart data={weeklyRates}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-gray-200 dark:stroke-gray-700" />
          <XAxis
            dataKey="week"
            tick={{ fontSize: 11 }}
            className="text-gray-400"
            tickFormatter={(w) => `W${12 - w}`}
          />
          <YAxis
            domain={[0, 100]}
            tick={{ fontSize: 11 }}
            className="text-gray-400"
            tickFormatter={(v) => `${v}%`}
          />
          <Tooltip
            formatter={(value) => [`${value}%`, 'Completion']}
            contentStyle={tooltipStyle()}
          />
          <Line
            type="monotone"
            dataKey="rate"
            stroke={color}
            strokeWidth={2}
            dot={{ fill: color, r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function DayOfWeekChart({ dayOfWeekCounts, color }) {
  const data = DAY_LABELS.map((label, i) => ({
    day: label,
    count: dayOfWeekCounts?.[i] || 0,
  }));

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-4">
      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
        Best Days
      </h3>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-gray-200 dark:stroke-gray-700" />
          <XAxis dataKey="day" tick={{ fontSize: 11 }} className="text-gray-400" />
          <YAxis tick={{ fontSize: 11 }} className="text-gray-400" />
          <Tooltip
            contentStyle={tooltipStyle()}
          />
          <Bar dataKey="count" fill={color} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
